import { z } from 'zod'

export const evaluationStatusSchema = z.enum(['pass', 'fail'])

export type EvaluationStatus = z.infer<typeof evaluationStatusSchema>

export const evaluationFormSchema = z.object({
  requirementEvaluations: z.record(evaluationStatusSchema),
  questionEvaluations: z.record(evaluationStatusSchema),
  questionJustifications: z.record(z.string().optional()),
})

export type EvaluationFormSchema = z.infer<typeof evaluationFormSchema>

export const emptyEvaluationFormValues = (): EvaluationFormSchema => ({
  requirementEvaluations: {},
  questionEvaluations: {},
  questionJustifications: {},
})

export const createEvaluationFormSchema = (questionIds: number[]) =>
  evaluationFormSchema.superRefine((data, ctx) => {
    const hasAllSelections = questionIds.every(
      (id) => data.questionEvaluations[String(id)] != null
    )
    if (!hasAllSelections) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Please select Pass or Fail for every question.',
        path: ['questionEvaluations'],
      })
    }
  })
